import moment from 'moment-timezone';
import Store from 'Services/Store';
import NylasScheduler from 'vcomponents/scheduler/NylasScheduler.vue';
import Feature from 'Services/Feature';

window.Agenda = {

	calendar						: null,
	tempEvents						: [],
	forceReload						: false,
	dashboardCalendarData			: null,
	dashboardCalendarProcessing		: false,
	translations: {
		allDay				: Loc.g("Toute la journée"),
		noEvent				: Loc.g("Il n'y a aucun évènement à afficher"),
		googleEvent			: Loc.g("Les évènements Google ne sont pas modifiables depuis Sellsy."),
		privateEvent		: Loc.g("Vous ne pouvez pas voir les détails de cet évènement car il est privé."),
		noMoveEvent			: Loc.g("Vous ne pouvez pas déplacer cet évènement car il s'agit d'un évènement récurrent."),
		recurringEvent		: Loc.g("Vous ne pouvez pas modifier la plage horaire de cet évènement car il s'agit d'un évènement récurrent."),
		readOnlyCalendar	: Loc.g("Vous ne pouvez pas effectuer d'action sur ce calendrier car il est en lecture seule."),
		titlePreview		: Loc.g("Détails de l'évènement"),
		closeButton			: Loc.g("Fermer"),
		modifyButton		: Loc.g("Modifier"),
		deleteButton		: Loc.g("Supprimer"),
		titleNewPlugin		: Loc.g("Nouvelle version du module Google Sync"),
		synchro				: Loc.g("Synchrnoiser"),
		eventPrivate		: Loc.g("Cet évènement est privé"),
		updateCalendarKo	: Loc.g("Vous devez enregistrer vos préférences avant de lancer l’action de mise à jour des calendriers."),
		updateCalendar		: Loc.g("Le temps de synchronisation des calendriers peut être important en fonction du nombre de calendrier à synchroniser. <br/>Veuillez patienter, ce message disparaitra automatiquement à la fin de la synchronisation"),
		deleteAlert			: Loc.g("Attention, cette action est irreversible.<br/><br/>Voulez vous continuer ?"),
		titleCreateMassTask	: window.i18n.gettext('Créer une tâche en masse'),
	},

	settings: {
		route : "agenda",
	},

	dashboardCalendarPaginationData : {
		locked	: false,	// to lock AJAX loading
		page	: 1,		// cause we load page 0 at the load of the dashboard,
		staff	: 0			// if we've a staff filter, we'll set it at something different than 0
	},

	initFilter: function(origin) {

		var multipleSelectOptions = {
			selectAll		: false,
			countSelected 	: false,
			selectAllText	: Loc.g('Tout Sélectionner'),
			allSelected		: Loc.g('Tous sélectionnés'),

			onOptgroupClick: function(view){
				Agenda.saveFilters(origin, 'staff');
			},

			onClick: function(view) {
				Agenda.saveFilters(origin, 'staff');
			},

			width : 300
		};

		if(origin == 'object'){
			var staffGroup = $('#pref_staffGroup').length > 0 ? $('#pref_staffGroup') : null;
			staffGroup && staffGroup.multipleSelect(multipleSelectOptions);

			//On modifie le placement des éléments
			$("#prefStaffGroup li").each(function() {
				if(!$(this).hasClass('group')){
					$(this).css("margin-left", "15px");
				}
			});
		} else {
			var staffGroup = $('#agenda_staffGroup').length > 0 ? $('#agenda_staffGroup') : null;
			staffGroup && staffGroup.multipleSelect(multipleSelectOptions);

			//On modifie le placement des éléments
			$("#staffGroup li").each(function() {
				if(!$(this).hasClass('group')){
					$(this).css("margin-left", "15px");
				}
			});
		}
	},

	addStaffToTaskCallback: function(item){
		var newstaff = $('#agendaEventForm .agendaEvent_staffContainer .agendaEvent_staff_TEMPLATE').clone();
		newstaff.attr('id', "agendaEvent_staff_"+item.id).attr('class','mb-2');
		newstaff.find('.staffAvatar').html(item.avatar);

		var avatarSpan = newstaff.find('.staffAvatar span');

		var avatarImg = newstaff.find('.staffAvatar span');

		newstaff.find('.staffDescription').html(item.name);
		newstaff.find('input').attr('name', "aevent_staff_edit["+item.id+"][]");
		newstaff.find('input').attr('id', "aevent_staff_edit_"+item.id+"");
		newstaff.find('label').attr('for', "aevent_staff_edit_"+item.id+"");
		$('#agendaEventForm .agendaEvent_staffContainer').append(newstaff);
		MyFacture.customForm($('#agendaEventForm'));


	},

	deleteStaffToTaskCallback : function(item){
		$('#agendaEventForm .agendaEvent_staffContainer #agendaEvent_staff_'+item.id).fadeOut().remove();
	},

	resizeDashTask: function(){

		var a 		= $('#dashboard #agendaTask .agenda-container');
		var open 	= 'N';

		if (a.hasClass('large')){
			a.removeClass('large');
		}
		else {
			a.addClass('large');
			open = 'Y';
		}
	},

	initCalendar: function(startTime, endTime, days, viewSelected, forceLocation) {

		var calendar	 = $("#calendar");
		var relatedtype  = calendar.attr('relatedtype');
		var relatedid	 = calendar.attr('relatedid');
		var aspectratio  = calendar.attr('ratio');
		var defaultView  = calendar.attr('defaultView');
		var headerLeft	 = calendar.attr('headerLeft');
		var headerCenter = calendar.attr('headerCenter');
		var headerRight  = calendar.attr('headerRight');
		var selectable	 = calendar.attr('selectable');
		var uiLang		 = Loc.uilang;
		var hoursFormat  = Store.get('corp').hourformat;
		var timeformat	 = hoursFormat === "12" ? 'hh:mm a' : 'HH:mm';

		relatedtype		= relatedtype === undefined ? 0 : relatedtype;
		relatedid		= relatedid === undefined ? 0 : relatedid;
		aspectratio		= aspectratio === undefined ? 1.35 : parseFloat(aspectratio);
		defaultView		= defaultView === undefined ? 'agendaDay' : defaultView;
		selectable		= selectable === undefined ? true : (selectable === 'Y');
		days			= days === undefined ? "" : days;
		viewSelected 	= viewSelected === undefined ?	'agendaDay'	: viewSelected;
		forceLocation 	= forceLocation === undefined ?	false : forceLocation;
		headerLeft	 	= headerLeft === undefined ? 'title' : headerLeft;
		headerCenter 	= headerCenter === undefined ? 'agendaDay, agendaWeek, month, listDay, listWeek, listMonth, listYear' : headerCenter;
		headerRight 	= headerRight === undefined ? 'refreshButton, prev, today, next' : headerRight;

		var hiddenDays      = days.split("-");
		var listHiddenDays  = new Array();

		for (var i = 0; i < hiddenDays.length; i++) {
			if (hiddenDays[i] !== "") {
				listHiddenDays.push(parseInt(hiddenDays[i]));
			}
		}

		// INIT FULLCALENDAR PLUGIN

		Agenda.calendar = $('#calendar').fullCalendar({

			customButtons: {
				refreshButton: {
					text:'',
					click: function () {
						$('#calendar').fullCalendar('refetchEvents');
					}
				}
			},

			buttonIcons: {
				prev		: ' icon-arrow-back',
				next		: ' icon-arrow-back rotated-180'
			},

			// Style
			header: {
				left	: headerLeft,
				center	: headerCenter,
				right	: headerRight
			},

			aspectRatio				: aspectratio,
			handleWindowResize		: false,
			nextDayThreshold		: "00:00:00",
			// Traduction && Formatting
			timeFormat				: timeformat,
			slotLabelFormat			: timeformat,
			firstDay				: (uiLang === 'fr') ? 1 : 0,
			weekNumbers				: true,
			weekNumberTitle			: (uiLang === 'fr') ? 'S' : 'W',
			weekNumberCalculation	: 'ISO',
			slotDuration			: '00:15:00',
			minTime					: startTime,
			maxTime					: endTime == "00:00:00" || endTime == "00:00" ? "24:00:00" : endTime,
			nowIndicator			: true, //Indicateur de l'heure actuel
			now 					: moment().tz(window.sellsyapp.$store.state.user.timezone).format(),

			// Display end time of event
			displayEventEnd	: true,
			defaultView		: viewSelected,
			hiddenDays 		: listHiddenDays,

			allDayText	: this.translations.allDay,
			navLinks 	: true,
			navLinkDayClick: function(date, jsEvent) {
				var params = {};
				var allDay		= 'N';
				var startFormatted	= date.format('YYYY-MM-DD HH:mm:ss');
				var endFormatted	= date.format('YYYY-MM-DD 23:59:59');

				params.start	= startFormatted;
				params.end		= endFormatted;
				params.allDay	= allDay;

				Agenda.editForm('', '', relatedid, relatedtype, params, 'event', '', true);
			},
			buttonText: {
				today: Loc.g("Aujourd'hui")
			},
			monthNames		: [Loc.g('Janvier'), Loc.g('Février'), Loc.g('Mars'), Loc.g('Avril'), Loc.g('Mai'), Loc.g('Juin'), Loc.g('Juillet'), Loc.g('Août'), Loc.g('Septembre'), Loc.g('Octobre'), Loc.g('Novembre'), Loc.g('Décembre')],
			monthNamesShort	: [Loc.g('Jan'), Loc.g('Fev'), Loc.g('Mar'), Loc.g('Avr'), Loc.g('Mai'), Loc.g('Jui'), Loc.g('Juil'), Loc.g('Au'), Loc.g('Sep'), Loc.g('Oct'), Loc.g('Nov'), Loc.g('Dec')],
			dayNames		: [Loc.g('Dimanche'), Loc.g('Lundi'), Loc.g('Mardi'), Loc.g('Mercredi'), Loc.g('Jeudi'), Loc.g('Vendredi'), Loc.g('Samedi')],
			dayNamesShort	: [Loc.g('Dim'), Loc.g('Lun'), Loc.g('Mar'), Loc.g('Mer'), Loc.g('Jeu'), Loc.g('Ven'), Loc.g('Sam')],

			views: {
				week: { // name of view
					titleFormat : 'DD MMMM YYYY',
					columnFormat : 'dddd DD/MM',
					buttonText : Loc.g('Semaine'),
				},
				day: { // name of view
					titleFormat: 'dddd DD MMMM YYYY',
					columnFormat : 'dddd',
					buttonText : Loc.g('Jour'),
				},
				month: { // name of view
					columnFormat : 'dddd',
					buttonText : Loc.g('Mois'),
				},
				listYear: {
					buttonText : Loc.g('Année'),
				},
				listMonth: {
					buttonText : Loc.g('Mois'),
				},
				listWeek: {
					buttonText : Loc.g('Semaine'),
				},
				listDay: {
					buttonText : Loc.g('Jour'),
				}
			},

			listDayFormat	: 'dddd DD MMMM YYYY',
			noEventsMessage : this.translations.noEvent,

			// Render
			eventRender : function(event, element, view) {

				element.click(function (e) {
					e.preventDefault();
					if (e.target.href) {
						window.location.href = e.target.href;
					} else {
						Agenda.preview(event.id, event.calendarId, event.isPrivate, event.start != null ? event.start._i : "", event.end != null ? event.end._i : "", event.isEventRecurring, event.title);
					}
				});
				// time render, removed if not in month view (when there is one)
				element.find('.fc-widget-content').css('min-height', '80px');
				var timeDiv = element.find('.fc-time');
				if(timeDiv) {
					timeDiv.remove();
				}

				// to force textColor in black
				element.css('color', event.textColor);

				// to put the bracket at left
				if (view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear") {
					element.css({
						'padding'			: '7px 5px',
						'border-radius'		: '0px',
						'border-left-color'	: '10px solid #FFF'
					})
				} else {
					element.css({
						'padding'			: '7px 5px',
						'border-radius'		: '0px',
						'border-left-color'	: '3px solid #FFF'
					})
				}

				// style
				if (event.backgroundColor === undefined) {
					event.css({
						'background'	: '#F7FBFD',
						'border-color'	: '#F7FBFD'
					})
				}

				if(event.backgroundColorRgba){
					element.css({
						'background'		: 'rgba(' + event.backgroundColorRgba + ')',
						'border-color'		: 'rgba(' + event.backgroundColorRgba + ')',
						'border-left-color'	: event.labelcolor,
						'opacity'			: event.opacity
					})
				} else {
					element.css({
						'background'		: event.backgroundColor,
						'border-color'		: event.borderColor,
						'border-left-color'	: event.labelcolor,
						'opacity'			: event.opacity
					})
				}

				var title = event.titleFormatted;
				title = title.replace(/&lt;/ig, "<").replace(/&gt;/ig, ">");
				if(view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear"){
					element.find('.fc-list-item-title')
							.html(title)
							.css('display', 'inline-block')
							.css('width', 'calc(100% - 50px)')
							.css('min-height', 'auto')
							.css('white-space', 'normal');
					// Put the color of the dot in the list view
					element.find('.fc-event-dot')
							.css('background-color', event.labelcolor)
					if(event.declinedParticipation == 'Y'){
						element.find('.fc-list-item-title').css('text-decoration', 'line-through');
					}
				} else {
					element.find('.fc-title')
							.html(title)
							.css('display', 'inline-block')
							.css('width', 'calc(100% - 45px)')
							.css('white-space', 'normal');
					if(event.declinedParticipation == 'Y'){
						element.find('.fc-title').css('text-decoration', 'line-through');
					}
				}

				// render
				var actualContent = element.find('.fc-content').html();
				if(view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear"){
					actualContent = element.find('.fc-list-item-title').html();
				}

				var hasLinked = false;
				var contentLinked = '';
				if (event.linkedurl !== undefined && event.linkedurl !== '') {
					hasLinked = true;
					contentLinked = '<span class="eventLinked" style="float:left;"><i class="fa ' + event.iconObject + '" style="margin-right: 2px;"></i> '+event.linkedurl+'</span>';
				}

				let mainContent = '<div>';
				if(event.isPrivate == "Y"){
                    mainContent += '<i class="fa fa-lock" style="margin-left:5px; float:right;"/>';
				} else if(event.nbAnnotations > 0) {
					mainContent += '<div style="margin-right:2px; float:right; margin-left:5px;"><span><i class="fa icon-conversation" onclick="Agenda.editAnnotations(this, \'' + event.id + '\', \'' + event.calendarId + '\')" tips="' + i18n.__("Commentaires") + '" positiontips="left"></i>     ' + event.nbAnnotations + '</span></div>';
				} else {
					mainContent += '<div style="margin-right:2px; float:right; margin-left:5px;"><i class="fa icon-conversation" onclick="Agenda.editAnnotations(this, \'' + event.id + '\', \'' + event.calendarId + '\')" tips="' + i18n.__("Commentaires") + '" positiontips="left"/></div>';
				}

				if (event.avatar) {
					var avatarOverlay = (event.nbStaff > 1) ? '<span style="position:absolute;top:0;left:0;margin:0 auto;background:rgba(255,255,255,0.7);width:25px;height:25px;line-height:24px;">' + event.nbStaff + '</span>' : '';
					if ('picture' == event.avatarType) {
						mainContent += '<span class="avatar avatar-picture avatar-small mr-0 fright prelative" tips="' + event.tips + '" positiontips="top"></i> ' +avatarOverlay+ "<img src='" + event.avatar + "'/>"  + '</span>';
					} else if ('initials' == event.avatarType) {
						mainContent += '<span class="avatar avatar-small mr-0 fright prelative" tips="' + event.tips + '" positiontips="top"></i> ' +avatarOverlay+ event.avatar + '</span>';
					}
				}
				mainContent +=  actualContent + '</div>' + (hasLinked ? '<div>' + contentLinked + '</div>' : '');

				var content = '<div>';
				content     += '<div style="width: 100%; display: inline-block; vertical-align: top;">' + mainContent + '</div>';
				content     += '</div>';

				if(view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear"){
					element.find('.fc-list-item-title').html(content);
				} else {
					element.find('.fc-content').html(content);
				}

				return;
			},

			eventAfterAllRender: function(view) {
				//On affiche ou cache les vues listes ou calendrier en fonction de la vue sélectionnée
				if(view.type == 'month' || view.type == 'agendaWeek' || view.type == 'agendaDay') {
					Agenda.changeView('calendar', false);
				} else {
					Agenda.changeView('list', false);
				}
				$('#calendar-loader').hide();
				Qtip.init();
				Agenda.initActiveDisplayMode();
			},

			// Event Dragging & Resizing
			editable	: true,
			eventDrop	: function (event, delta, revertFunc, jsEvent, ui, view) {
				Agenda.uiActionCallback(event, "drop");
			},

			eventResize	: function (event, delta, revertFunc, jsEvent, ui, view) {
				Agenda.uiActionCallback(event, "resize");
			},

			// Selection
			selectable		: selectable,
			selectHelper	: false,

			select: function (start, end, jsEvent, view) {
				var params 			= {};
				var allDay          = (start.hasTime() && end.hasTime()) ? 'N' : 'Y';
				var startFormatted  = start.format('YYYY-MM-DD HH:mm:ss');
				var endFormatted    = '';

				if (allDay === 'Y') {
					end.subtract(1, 'day');
					endFormatted = end.format('YYYY-MM-DD 23:59:59');
				} else {
					endFormatted = end.format('YYYY-MM-DD HH:mm:ss');
				}

				params.start	= startFormatted;
				params.end		= endFormatted;
				params.allDay	= allDay;
				Agenda.editForm('', '', relatedid, relatedtype, params, 'event', '', true);
			},

			// Events
			lazyFetching	: false,
			events			: function (start, end, timezone, callback) {
				MyFacture.cleanQueue();
				$('#calendar-loader').show();

				var href        = document.location.href;
				var href_array	= (href.search(/\?_f=/)) >= 0 ? href.split('?_f=') : href.slice(8).split('/');
				var isDashboard = ($('#dashboard').length > 0) ? "Y" : "N";

				var action = "agenda&action=updateEvents&forCalendar=Y&relatedtype=" + relatedtype + "&relatedid=" + relatedid + "&displayAll=Y";

				var view = $('#calendar').fullCalendar('getView');
				var dataAction = {
					start: start.format('YYYY-MM-DD HH:mm:ss'),
					end: end.format('YYYY-MM-DD HH:mm:ss'),
					location: forceLocation ? forceLocation : href_array[1],
					offset: 0,
					view: view.name
				};

				var success = function (data) {
					Listing.loader('hide', 'agendaListing');

					if(data.type && data.type == "error"){
						Push.error(data.message);
                        $('#calendar-loader').hide();
                        callback([]); // need this to properly initialize the plugin
                        Agenda.setHeight()
					}
					else {

						$('#calendar').fullCalendar('removeEvents');

						Agenda.tempEvents = [];
						if (data.length > 0) {
							for (var i in data) {
                                var event = data[i];
                                if (data[i].editable === 'N') {
                                    data[i].editable = false;
                                }
								Agenda.tempEvents[event.id] = event;
							}
                        }
                        callback(data);
                        Agenda.setHeight()
					}
				};
				MyFacture.post(action, dataAction, success, 'json', (isDashboard === 'N'));
			}
		});

		// REFRESH BUTTON
		$(".fc-refreshButton-button").addClass("icon-refresh mr-4");
	},

	/**
	 *
	 * @param {Object} event
	 * @param {string} action
	 */
	uiActionCallback(event, action) {
		if (event.isEventRecurring == "Y") {
			Agenda.popupWarningEvent(action);
		} else {
			if (!Agenda.eventIsFromGoogle(event)) {
				Agenda.prepareDropOrResize(event);
			} else {
				Agenda.popupFromGoogle();
			}
		}
	},

    setHeight: function() {
        var isDashboard = ($('#dashboard').length > 0) ? "Y" : "N";
        if (isDashboard === 'N') {
            setTimeout(function() {
                $('#calendar').fullCalendar('option', 'contentHeight', 'auto');
            }, 1000)
        }
    },

	editAnnotations : function(contexte, eventId, calendarId) {

		var buttons = [];
		buttons.push({
			text : Loc.g("Fermer"),
			'class' : 'btn btn-gray',
			click : function(){
				$(this).dialog("close");
				Agenda.refreshAgenda();
			}
		});

		var options = {
			title	: "Commentaires",
			buttons	: buttons,
			width : 600,
			callback	: function(){
				Annotation.init("cardComments");
			}
		};


		MyWindow.load(
			"agenda",
			{
				action		: "editAnnotations",
				eventId		: eventId,
				calendarId	: calendarId
			},
			options
		);
	},

	initQtip : function(instanceEvent, eventId, calendarId, isPrivate, startDate, endDate){
		instanceEvent.qtip({
			style : {
				classes : 'custom-qtip rich-qtip',
				def		: false
			},
            position: {
                at: 'top center',
                my: 'right center',
                effect: false,
                viewport: $('.contentMargin'),
                adjust: {
                    method: 'none shift'
                }
            },
			content: {
				ajax: {
					url     : './?_f=agenda',
					type 	: 'GET',
					data    : {
						action		: 'tipslog',
						eventId		: eventId,
						calendarId	: calendarId,
						startDate	: startDate,
						endDate		: endDate,
						isDashboard : 'Y'
					},
					once: true
				}
			},
			show : {
				event : 'click'
			},
			hide: {
				fixed: true,
				delay: 100
			}
		});
	},

	prepareDropOrResize: function(event, isDrop) {
		isDrop = ((isDrop === undefined) ? false : isDrop);

		var start	= event.start;
		var end		= event.end;
		if(end === null){
			end		= start;
		}
		var allDay			= (start.hasTime() && end.hasTime()) ? 'N' : 'Y';

		var startFormatted	= start.format('YYYY-MM-DD HH:mm:ss');
		var endFormatted	= '';
		endFormatted		= end.format('YYYY-MM-DD HH:mm:ss');

		if(isDrop) {
			var newEvent = event;
			var oldEvent = Agenda.tempEvents[event.id];

			if (newEvent.allDay === true && oldEvent.allDay === false) {
				// end date is 1 day too late
				end					= end.add(1, 'days');
				endFormatted		= end.format('YYYY-MM-DD HH:mm:ss');
				Agenda.forceReload	= true;
			} else if (newEvent.allDay === false && oldEvent.allDay === true) {
				// need to put 1h between start and end dates
				end					= end.add(2, 'hours');
				endFormatted		= end.format('YYYY-MM-DD HH:mm:ss');
				Agenda.forceReload	= true;
			} else if (newEvent.allDay === true && oldEvent.allDay === true) {
				// need to remove 1 day at end date
				// end					= end.subtract(1, 'days');
				endFormatted		= end.format('YYYY-MM-DD HH:mm:ss');
				Agenda.forceReload	= true;
			}

			Agenda.tempEvents[event.id].allDay = newEvent.allDay;
		}

		Agenda.dropOrResize(event.id, event.calendarId, startFormatted, endFormatted, allDay);
	},

	eventIsFromGoogle : function(event) {
		var classname = event.className;
		var isGoogle = false;
		for(var i = 0; i < classname.length;i++){
			if(classname[i] === 'google'){
				isGoogle = true;
			}
		}
		return isGoogle;
	},

	popupFromGoogle : function() {
		MyWindow.alert(
			this.translations.googleEvent,
			{
				type : 'warning'
			}
		);
	},

    changeView: function (view, selectView) {
		if (view == "list") {
			$('.fc-agendaDay-button').hide();
			$('.fc-agendaWeek-button').hide();
			$('.fc-month-button').hide();
			$('.fc-listYear-button').show();
			$('.fc-listMonth-button').show();
			$('.fc-listWeek-button').show();
			$('.fc-listDay-button').show();
			if (selectView) {
				$('.fc-listMonth-button').click();
			}
		} else if (view == "calendar") {
			$('.fc-listYear-button').hide();
			$('.fc-listMonth-button').hide();
			$('.fc-listWeek-button').hide();
			$('.fc-listDay-button').hide();
			$('.fc-agendaDay-button').show();
			$('.fc-agendaWeek-button').show();
			$('.fc-month-button').show();
			if (selectView) {
				$('.fc-month-button').click();
			}
		}
	},

	popupWarningEvent : function(type) {
		if(type == "private"){
			MyWindow.alert(
				this.translations.privateEvent,
				{
					type : 'warning'
				}
			);
		} else if(type == "drop"){
			MyWindow.alert(
				this.translations.noMoveEvent,
				{
					type : 'warning'
				}
			);
			$('#calendar').fullCalendar('refetchEvents');
		} else if(type == "resize"){
			MyWindow.alert(
				this.translations.recurringEvent,
				{
					type : 'warning'
				}
			);
			$('#calendar').fullCalendar('refetchEvents');
		} else if(type == "nylas"){
			MyWindow.alert(
				this.translations.readOnlyCalendar,
				{
					type : 'warning'
				}
			);
		} else if(type == "inProgress"){
			MyWindow.alert(
				Loc.g("Développement en cours."),
				{
					type : 'warning'
				}
			);
		}
	},

	show: function(id) {
		var options = {
			title : Loc.g("Evenement"),
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click : function(){
						$(this).dialog("close");
					}
				}
			]
		};
		MyWindow.load(
			"agendaEvent",
			{
				action:"show",
				id:id
			},
			options
		);
	},

	dropOrResize: function(id, calendarId, start, end, allDay) {

		var callback = function(data) {
            if (data.status == 'failed' && data.error) {
                Push.error(data.error);
            }

			if(Agenda.forceReload) {
				$('#calendar').fullCalendar('refetchEvents');
				Agenda.forceReload = false;
			}
		};

		MyFacture.post(
			'agendaEvent',
			{
				'action'	: "dropOrResize",
				"id"		: id,
				"calendarId": calendarId,
				"start"		: start,
				"end"		: end,
				"allDay"	: allDay
			},
			callback,
			"json"
		);
	},

	showHistory: function(relatedid, relatedtype){

		var options = {
			title : Loc.g("Historique des tâches"),
			buttons	: [{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}}],
			callback : function(){
				$('#agenda-history .nano').nanoScroller({preventPageScrolling: true});

				$("#agenda-history .nano").debounce("scrollend", function(e){
					var trigg = $('#agenda-history .moreBtn a');
					if (!trigg.hasClass('stop') && trigg.is(':visible')){
						$('#agenda-history .moreBtn a').trigger('click');
						$('#agenda-history .nano').nanoScroller({preventPageScrolling: true});
					}
				});
			}
		};

		MyWindow.load(
			"agendaEvent",
			{
				action		: "taskHistory",
				relatedid	:relatedid,
				relatedtype	:relatedtype
			},
			options
		);
	},

	moreHistory: function(relatedid, relatedtype){

		var page = $('#history_next_page').val();
		var moreBtn = $('#agenda-history .moreBtn a');
		moreBtn.addClass('stop')
		MyFacture.beLoading(moreBtn);
		MyFacture.post(
				'agendaEvent',
				{
					'action' : "taskHistory",
					relatedid : relatedid,
					relatedtype : relatedtype,
					page : page
				},
				function(data){
					$('#agenda-history #agenda-history-list').append(data.agendaHistoryRows);
					$('#agenda-history .moreBtn a').removeClass('stop')
					if (data.nbRows == 0){
						$('#agenda-history .moreBtn a').remove();
					}
				}, "json");

		$('#history_next_page').val(parseInt(page)+1);

	},

	cardForm: function(id, calendarId, type, editable, fromDashboard, startDate, endDate, isEventRecurring, relatedType = ''){

		var popupName       = (type === undefined || type == "task")    ? Loc.g("Détail de la tâche")   : Loc.g("Détail de l'évènement");
		var btnText         = (type === undefined || type == "task")    ? Loc.g("Modifier la tâche")    : Loc.g("Modifier l'évènement");
		var editable        = editable === undefined                    ? false                         : editable === "Y";
		var fromDashboard   = fromDashboard === undefined               ? false                         : fromDashboard;

		if(type === 'task' && Feature.isEnabled('activity-new-creation-panel') && ![ 'delivery',
			'proforma'].includes(relatedType)) {
			Popup.openPopup({
				key: 'activityDetailPanel',
				props: {
					activityDetailDisplayed: {
						id: id,
						type: 'task',
						related: [],
					},
					shouldFetchAdditionalData: true
				},
			})
			return;
		};

		var buttons = [];

		if (editable) {

			buttons.push({
				text	: Loc.g("Supprimer"),
				click	: function() {
					if(isEventRecurring == "Y"){
						Agenda.checkDeleteRecurring(id, calendarId, type);
					} else {
						Agenda.deleteAlert(id, calendarId, false, "N", type, '', '', '');
					}
					$(this).dialog("close");
				}
			});

            buttons.push({
				text : btnText,
				'class': "btn-task__modifier",
				click : function(){
					Agenda.editForm(id, calendarId, undefined, undefined, undefined, type, undefined, undefined, isEventRecurring, startDate, endDate);
				}
            });
		}

		var options = {
			title	: popupName,
			buttons	: buttons,
			dialogClass : "white",
			width : 900,
			callback	: function(){
				BriefCaseV2Light.init();
				Annotation.init("cardComments");
			}
		};
		if(startDate !== undefined && endDate !== undefined && isEventRecurring !== undefined){
			MyWindow.load("agendaEvent", {action:"cardForm", id:id, calendarId:calendarId, startDate:startDate, endDate:endDate, isEventRecurring:isEventRecurring, type:type}, options);
		} else {
			MyWindow.load("agendaEvent", {action:"cardForm", id:id, calendarId:calendarId, type:type}, options);
		}
	},

        checkDeleteRecurring : function (id, calendarId, type, tsStartRecurringEvent, title){
            var buttons = [];

            buttons.push({
				text : Loc.g("Annuler"),
				click : function(){
					$(this).dialog("close");
				}
			});
			buttons.push({
				text : Loc.g("Supprimer"),
				'class' : 'btn-default',
				click : function(){
					Agenda.deleteAlert(id, calendarId, false, "Y", type, tsStartRecurringEvent, $('input[name=aevent_checkRecurring]:checked').val(), title);
					$(this).dialog("close");
				}
			});

            var options = {
				title   : Loc.g("Vérification de l'évènement récurrent"),
				buttons : buttons,
				width   : 900
            };
            MyWindow.load(
				"agendaEvent",
				{
					action:"checkRecurring"
				},
				options,
				undefined,
				'idCheckDeleteRecurring'
			);
        },

        checkRecurring : function () {

            var formID	= 'agendaEventForm';
            var buttons = [];

			buttons.push({text : Loc.g("Annuler"), click : function(){
				$(this).dialog("close");
			}});

			buttons.push({text : Loc.g("Enregistrer"), click : function(){
				$('#aevent_typeModifyRecurring').val($('input[name=aevent_checkRecurring]:checked').val());
				!$('body').data(formID+'Disabled') && $("#"+formID).submit();
				$(this).dialog("close");
			}});

            var options = {
				title   : Loc.g("Vérification de l'évènement récurrent"),
				buttons : buttons,
				width   : 900
            };

            MyWindow.load(
				"agendaEvent",
				{
					action : "checkRecurring",
					displayButtonAll : $('#aevent_recurring_displayButtonAll').val()
				},
				options,
				undefined,
				'idCheckRecurring'
			);
        },

		editForm : function(id, calendarId, relatedid, relatedtype, params, type, customCallback, fromAgenda, isEventRecurring, startDateEvent, endDateEvent, title){
			var eventID				= id === undefined ? '' : id;
			var customCallback		= customCallback == undefined ? '' : customCallback;
			var fromAgenda			= fromAgenda == undefined ? false : fromAgenda;
			var today				= new Date();
			var todayFormatted		= today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
			var todayEndFormatted	= today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate() + " " + (today.getHours() + 1) + ":" + today.getMinutes() + ":" + today.getSeconds();
			var paramsToSend		= params == undefined ? {start: todayFormatted, end: todayEndFormatted} : params;
			var formID				= 'agendaEventForm';

			var popupTitle = Loc.g("Créer un évènement");
			if (id === '' && type === 'task'){
				popupTitle = Loc.g("Programmer une tâche");
			} else if (id != '') {
				popupTitle = Loc.g('Modification');
			}

			var options = {
				dialogClass: "white",
				title: popupTitle,
				width: MyWindow.small,
				buttons: [
					{
						text	: Loc.g("Annuler"),
						'class' : 'btn-default',
						click	: function () {
							$(this).dialog("close");
						}
					},
					{
						text	: Loc.g("Enregistrer"),
						'class' : 'btn-primary',
						click	: function (btn) {
                            MyWindow.wait();
							if (isEventRecurring == 'Y') {
								Agenda.checkRecurring();
							} else {
								!$('body').data(formID + 'Disabled') && $("#" + formID).submit();

								MyForm.toggleDisabledForm({
									btn: $(btn.currentTarget),
									dataToCheckOnBody: formID + 'Disabled'
								});
							}
						}
					}
				],
				callback : function(data){
					if (data?.event?.message) {
						MyWindow.close();
						Push.error(data.event.message);
					} else {
						Agenda.prepareForm(fromAgenda, customCallback, eventID == '', paramsToSend);
						BriefCaseV2Light.init();
					}
                    window.Agenda.getComponentNylasScheduler('#nylas-scheduler-container');
				}
			};

			if (id !== '') {
				options.buttons.splice(0, 1, {
					text	: Loc.g("Supprimer"),
					'class' : 'btn-default',
					click	: function () {
						if(isEventRecurring == "Y")
							Agenda.checkDeleteRecurring(id, calendarId, type, $("#aevent_tsStartRecurringEvent").val(), title);
						else
							Agenda.deleteAlert(id, calendarId, false, "N", type, '', '', title);

						$(this).dialog("close");
					}
				});
			}

			var href        = document.location.href;
			var href_array	= (href.search(/\?_f=/)) >= 0 ? href.split('?_f=') : href.slice(8).split('/');

			if(startDateEvent !== undefined && endDateEvent !== undefined && isEventRecurring !== undefined){
				MyWindow.load(
					"agendaEvent",
					{
						action				: "agendaEventForm",
						eventid				: eventID,
						calendarId          : calendarId,
						type				: type,
						relatedtype         : relatedtype,
						relatedid			: relatedid,
						params				: paramsToSend,
						isEventRecurring    : isEventRecurring,
						startDateRecurring  : startDateEvent,
						endDateRecurring	: endDateEvent,
						location			: href_array[1]
					},
					options
				);
			} else {
				MyWindow.load(
					"agendaEvent",
					{
						action		: "agendaEventForm",
						eventid		: eventID,
						calendarId	: calendarId,
						type		: type,
						relatedtype : relatedtype,
						relatedid   : relatedid,
						params		: paramsToSend,
						location	: href_array[1]
					},
					options
				);
			}
		    let popupAgenda = document.getElementById("popupAgenda");
            if (popupAgenda) {
                const popupForm = document.getElementsByClassName("ui-corner-all ui-dialog ui-dialog-buttons ui-draggable ui-front ui-widget ui-widget-content")[0];
                const overlay = document.getElementsByClassName("ui-widget-overlay ui-front")[0];
                popupAgenda.append(overlay ?? "");
                popupAgenda.append(popupForm ?? "");

                const popinWin = document.getElementById("popupWindow");
                popinWin.style.maxHeight = "75vh";

				//put window on the top position
				popinWin.parentElement.style.zIndex = 3000;

                //special case for small screen
                if(window.innerHeight <= 768){
                    popupForm.style.top = popupAgenda.scrollTop;
                }
            }
		},

        changeFrequencyRecurrence : function () {
            var frequency = $('#aevent_recur_frequency').val();
            if(frequency == "daily"){
                $('#aevent_recur_periodicityDay').show();
                $('#aevent_recur_periodicityWeek').hide();
                $('#aevent_recur_periodicityMonth').hide();
                $('#formWeekMode').hide();
                $('#formMonthMode').hide();
            } else if(frequency == "weekly"){
                $('#aevent_recur_periodicityDay').hide();
                $('#aevent_recur_periodicityWeek').show();
                $('#aevent_recur_periodicityMonth').hide();
                $('#formWeekMode').show();
                $('#formMonthMode').hide();
                MyFacture.customForm();

            } else if(frequency == "monthly"){
                $('#aevent_recur_periodicityDay').hide();
                $('#aevent_recur_periodicityWeek').hide();
                $('#aevent_recur_periodicityMonth').show();
                $('#formWeekMode').hide();
                $('#formMonthMode').show();

            } else if(frequency == "yearly"){
                $('#aevent_recur_periodicityDay').hide();
                $('#aevent_recur_periodicityWeek').hide();
                $('#aevent_recur_periodicityMonth').hide();
                $('#formWeekMode').hide();
                $('#formMonthMode').hide();
            }
        },

	prepareForm : function(fromCalendar, customCallback, create, paramsData){
		var formId = 'agendaEventForm';
		var isDashboard = ($('#dashboard').length > 0) ? "Y" : "N";
		var isOverview = ($('#content_agenda').length > 0) ? "Y" : "N";
		var options = {
			success:function(data) {
				if (data.typeAction != undefined && data.typeAction == 'batch') {
					MyWindow.awake();
					MyWindow.close();
					Push.success(data.msg);
				} else {
					MyWindow.awake();
					if(data.status == "failed"){
						if (data.error != undefined) {
							Push.error(data.error);
						} else {
							const message = data.form?.fields?.map((field) => field.msg);
							Push.error(message.join(', '));
						}
					}

					if(data.eventNotInFilters != undefined && data.eventNotInFilters == 'Y') {
						MyWindow.alert(Loc.g('Evènement sauvegardé avec succès. (vos filtres actuels ne permettent pas de l‘afficher)'), {
							type: 'confirm'
						});
					}
					if (isDashboard == "Y") {
						$('#newStartDateEvent').val(0);
					}

					data.customCallback = customCallback;
					Agenda.recordCallback(data);

					if (data.majOppDueDate === 'N' && customCallback !== '') {
						typeof(customCallback) === 'function' ? customCallback(data) : eval(customCallback + '(data)');
					} else if (data.refresh) {
						if (data.event.type === 'task') {
							Agenda.updateNbTasksOverview("plus");
						}

						if(data.majOppDueDate !== 'Y'){
							Agenda.updateListingTasks();
						}
					}

					MyForm.toggleDisabledForm({
						btn: $('#popupWindow').next().find('button:first'),
						dataToCheckOnBody: formId + 'Disabled',
						toEnabled: true
                    });

                    if (data.status != 'failed') {
						window.EventBus.emit("refresh_" + data.event.type);

                        if (create) {
							window.EventBus.emit('timeline:processAndAdd', {entity: data.event.type, event: data.event.type + '.created', objectid: data.event.id, eventDetails: { 'provider': data.provider, 'uid': data.event.uid }});
							if (data.event.type === 'task' && paramsData.hasOwnProperty('stepId')) {
								window.EventBus.emit('form:opportunity:edit:success', { stepId: paramsData.stepId });
							}
                        } else {
                            window.EventBus.emit('timeline:refreshLog', {objectType: data.event.type, objectId: data.event.id});
                        }
                    }
				}
			},
			dataType: "json"
		};

		var target = $("#" + formId).attr('action');
		target = target == '' || target == undefined ? 'record' : target;

		var params = {
			'action'        : target,
			'isDashboard'	: isDashboard,
			'isOverview'	: isOverview,
			'fromCalendar'	: fromCalendar
		};

		MyForm.prepare(formId, "agendaEvent&"+$.param(params), options, true, true);
		MyFacture.customForm($("#agendaEventForm"));

		// switch evenement /tache
		$('.alert-type input').click(function () {
			var val = $(this).val();
			if (val === 'task') {
				$('.alert-start-time').hide('fast');
				$('.alert-end-time').find('td:first').html('Date :');
			} else {
				$('.alert-start-time').show('fast');
				$('.alert-end-time').find('td:first').html('Date de fin :');
			}
		});

		// Alertes
		$("#aevent_sendEmail").click(function () {
			$('#rappelTemplate li').clone().appendTo($('#listRappel'));
			MyFacture.customForm($('#listRappel'));

			if ($('#contactEmail').is((':hidden'))) {
				$('#contactEmail').show();
			}

			if ($('#rappels').is((':hidden'))) {
				$('#rappels').show();
			}
		});

		// Click toutes la journée => cache les champs heures
		$('#aevent_allDay').click(function () {
			if ($('input[name=aevent_allDay]:checked').val() === "Y") {
				$('.hourPicker').hide();
			} else {
				$('.hourPicker').show();
				$('.hourPicker').css('display', 'inline-block');
				MyFacture.customForm($('.hourPicker'));
			}
		});

		$('#aevent_use_recurrence').click(function() {
			if($('input[name=aevent_use_recurrence]:checked').val() === "Y"){
				$('#divRecurrence').show();
				MyFacture.customForm($('#divRecurrence'));
			}else {
				$('#divRecurrence').hide();
			}
		});

		// Suppression rappels
		$("#rappels").on("click", '.deleteRappel', function () {
			$(this).closest('.form-group').remove();
			if ($('#listRappel li').length === 0) {
				$('#rappels').hide();
			}
		});

		$('#aevent_recur_endNever').click(function() {
			$('#aevent_recur_endMode_msg').show();
		});
		$('#aevent_recur_endDate').click(function() {
			$('#aevent_recur_endMode_msg').hide();
		});
		$('#aevent_recur_endOccurences').click(function() {
			$('#aevent_recur_endMode_msg').hide();
		});

		// init relateds part of the popup
		Agenda.initRelateds();
	},

	recordCallback: function(data){
		var formIsOk = MyForm.processJson(data, "agendaEventForm");
		if(formIsOk) {
			var type = data.event.type;

			if (type !== "event" && type !== "agendaEventLink"){

				var new_item = $(data.eventHTML).hide();
				var currentTask = $('#aevent_'+data.event.id);

				currentTask.remove();

				$('.'+data.eventState+'container').append(new_item);

				MyWindow.close();

				if ($('.'+data.eventState+'container').prev().hasClass('hidden')){
					$('.'+data.eventState+'container').prev().removeClass('hidden');
				}

				$('.'+data.eventState+'container .noTask').remove();

				$('#aevent_'+data.event.id).slideDown();

				$('.agenda-container').find('.noEvent').hide();

				if ($('#dashboard').length > 0){
					$('#aevent_'+data.event.id).draggable({
						helper		: "clone",
						containment	: $('#agendaTask'),
						appendTo	: $('#agendaTask'),
						scroll		: false
					});
					$('.'+data.eventState+'container').find('li').tsort({order:'asc',attr:'start'});
				}

				MyFacture.customForm();
				if(data.majOppDueDate === 'Y'){
					Agenda.updateOppForm(data);
				}

			} else {
				$('#calendar').fullCalendar('refetchEvents');
				MyWindow.close();
			}

			Agenda.tempEvents[data.event.id] = data.event;
		}
		return true;

	},

	updateOppForm: function(data){

		var options = {
			width		: 400,
			resizable   : false,
			noclose     : true,
			title       : Loc.g("Mise à jour de la date d'échéance de l'opportunité"),
			buttons     : [
				{
					text : Loc.g("Ne rien faire"),
					'class'	: ' btn btn-default',
					click : function(){
						$(this).dialog("close");
						Agenda.updateListingTasks();
					}
				},
				{
					text : Loc.g("Mettre à jour"),
					click : function(){
						// action
						Agenda.updateOpp(data);
                        Agenda.updateListingTasks();
                        EventBus.emit('opportunity:update:endDate', data)
						$(this).dialog("close");
					}
				}
			]
		};
		MyWindow.alert(Loc.g('Souhaitez vous mettre à jour la date d‘échéance de l‘opportunité ?'), options);
	},

	updateOpp: function(data){
		var options = {
			action: 'updateOpp',
			datas: data,
		};

		MyFacture.post("agendaEvent", options, function(datas){
			if(datas.status === 'ok'){
				if(datas.customCallback !== ''){
					eval(datas.customCallback+'(data)');
				}
			}
		}, "json");
	},

	toggleTask: function(id){

		if ($('#aevent_' + id).hasClass('complete')){
			Agenda.uncompleteTask(id);
		} else {
			Agenda.completeTask(id);
		}

	},

	updateListingTasks : function (){
		if($('#tasksOverviewListing_container').length > 0){
			Listing.update('tasksOverviewListing');
		} else {
			Listing.update("tasksListing", true);
		}
	},

	updateNbTasksOverview : function (typeAction){
		if($('.tabTaskCount').length > 0){
			var nbTasks		= parseInt($('.tabTaskCount').text(), 10);
			if(typeAction === "plus"){
				var newNbTasks	= nbTasks + 1;
			} else {
				var newNbTasks	= nbTasks - 1;
			}
			if(newNbTasks < 1){
				$('.tabTaskCount').text(0).hide();
			}else{
				$('.tabTaskCount').text(newNbTasks).show();
			}
		}
	},

	completeTask: function(id){
		MyFacture.post(
			'agendaEvent',
			{
				'action' : "complete",
				"id" : id
			}
			,function(data){
				if(data.status == 'ok'){
					$('#aevent_' + data.eventID).addClass('complete');
					Agenda.updateListingTasks();
					Agenda.updateNbTasksOverview("minus");

				}else{
					MyWindow.alert(data.msg, {type : 'error'});
					$('#aevent_' + data.eventID+' label.checkbox').removeClass('ui-state-active');
				}
			},
			"json"
		);

	},

	completeTaskBatch: function(ids){
		var optionsPopup = {
			title	: Loc.g('Terminer des tâches'),
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			callback : function(){
				Listing.update("tasksListing");
			}
		};

		MyWindow.load("agendaEvent", {
			action	: "completeBatch",
			ids		: ids
		}, optionsPopup);

	},

	uncompleteTask: function(id){
		MyFacture.post('agendaEvent', {'action':"uncomplete", "id": id},function(data){
			if(data.status === 'ok'){
				$('#aevent_' + data.eventID).removeClass('complete');
				Agenda.updateListingTasks();
			}else{
				MyWindow.alert(data.msg, {type : 'error'});
				$('#aevent_' + data.eventID+' label.checkbox').addClass('ui-state-active');
			}
		}, "json");

	},

	createMassTask: function(relatedType, ids)
	{
		var self = this;
		var options = {
			title: self.translations.titleCreateMassTask,
			width: MyWindow.medium,
			buttons: [
				{
					text	: Loc.g("Annuler"),
					'class' : 'btn-default',
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
					'class' : 'btn-primary',
					click	: function (btn) {
						MyWindow.wait();
						$("#agendaEventForm").submit();
					}
				}
			],
			callback : function(data){
				$('#agendaEventForm').attr('action', 'recordMassCreateTask');
				Agenda.prepareForm(false, '', true);
			}
		};
		MyWindow.load('agendaEvent', { action: "createMassTask", relatedType : relatedType, ids : ids }, options);
	},

	uncompleteTaskBatch: function(ids){
		var optionsPopup = {
			title	: Loc.g('Marquer les tâches non terminées'),
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			callback : function(){
				Listing.update("tasksListing");
			}
		};

		MyWindow.load("agendaEvent", {
			action	: "uncompleteBatch",
			ids     : ids
		}, optionsPopup);
	},

	changeDateTaskBatch: function(ids){
		var options = {
			title: Loc.g("Mettre à jour la date"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () {
						var date = $('#newDateTask').val();
						var hour = $('#newHourTask').val();

						MyFacture.post('agendaEvent&action=changeDateTaskBatchRecord', {tasks: ids, date: date, hour : hour}, function (data) {
							MyWindow.close();
							var msg = Loc.g("Les dates et heures des tâches ont été modifiées.");
							MyWindow.alert(
								msg,
								{
									title: Loc.g('Mettre à jour la date'),
									type: 'info',
									buttons: [
										{
											text: Loc.g("Ok"),
											click: function () {
												$(this).dialog("close");
												Listing.update('tasksListing');
											}
										}
									],
								}
							);
						}, "json");
					}
				}
			],
			width: 600,
			callback: function () {}
		};
		MyWindow.load('agendaEvent', {action: "changeDateTaskBatch"}, options);
    },

    deleteTaskBatch: function(ids) {
		var self = this;
		var msg =  self.translations.deleteAlert;
		var options = {
			resizable	: false,
			noclose		: true,
			type		: 'warning',
			title		: Loc.g("Supprimer les tâches"),
			buttons		: [
				{
					text : Loc.g("Non"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){
						MyFacture.post('agendaEvent&action=deleteTaskBatch', {tasks: ids}, function (data) {
							if (data.result == 'ok') {
								Push.success(Loc.g("La suppression des tâches a été planifiée."));
								Listing.update('tasksListing');
							}
						}, "json");
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(msg, options);
	},

	changeOwnerTaskBatch: function(ids){
		var options = {
			title: Loc.g("Mettre à jour le propriétaire"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () {
						var ownerId = $('#tasks_ownerid').val();

						MyFacture.post('agendaEvent&action=changeOwnerTaskBatchRecord',
							{
								tasks: ids, ownerId: ownerId
							}, function (data) {
								MyWindow.close();
								Push.success(Loc.g("La mise à jour du propriétaire des tâches a été planifié."))
								Listing.update('tasksListing');
							}, "json"
						);
					}
				}
			],
			width: 600,
			callback: function () { MyFacture.customForm(); }
		};
		MyWindow.load('agendaEvent', {action: "changeOwnerTaskBatch"}, options);
	},

	changeStaffTaskBatch: function(ids){
		var formId = 'changeStaffTasksForm';
		var options = {
			title: Loc.g("Mettre à jour les collaborateurs"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () {
						var data = "";
						var staffId = $('#staff').val();
						var tmp = staffId.split(",");
						tmp.forEach(function(element) {
							var id = element.split("_");
							var idStaff = '';
							if (typeof id[1] == "undefined") {
								idStaff = id[0];
							} else {
								idStaff = id[1];
							}

							var status = $('#staff_edit_staff_' + idStaff).is(':checked') ? 'Y' : 'N';
							data += idStaff + '-' + status + '#';
						});

						MyFacture.post('agendaEvent&action=changeStaffTaskBatchRecord',
							{
								tasks: ids, data: data
							}, function (data) {
								MyWindow.close();
								Push.success(Loc.g("La mise à jour des collaborateurs des tâches a été planifié."))
								Listing.update('tasksListing');
							}, "json"
						);
					}
				}
			],
			dataType: "json",
			data : {
				ids		: ids,
				action	: "changeStaffTaskBatchRecord"
			},
			width: 600,
			callback: function () { MyFacture.customForm(); }
		};

		MyWindow.load('agendaEvent', {action: "changeStaffTaskBatch", tasks : ids}, options);
	},

	addStaffToTask : function(item)
	{
		var newstaff = $('#changeStaffTasksForm .staffContainer .staff_TEMPLATE').clone();
		newstaff.attr('id', "staff_" + item.id).attr('class','mb-2');
		newstaff.find('.staffAvatar').html(item.avatar);

		newstaff.find('.staffDescription').html(item.name);
		newstaff.find('input').attr('name', "staff_edit["+item.id+"][]");
		newstaff.find('input').attr('id', "staff_edit_"+item.id+"");
		newstaff.find('label').attr('for', "staff_edit_"+item.id+"");
		$('#changeStaffTasksForm .staffContainer').append(newstaff);
		MyFacture.customForm($('#changeStaffTasksForm'));
	},

	deleteStaffToTask : function(item)
	{
		$('#changeStaffTasksForm .staffContainer #staff_'+item.id).fadeOut().remove();
	},

	deleteAlert: function(id, calendarId, dashboard, isEventRecurring, type, startDateEventRecurring, typeDeleteRecurring, title) {
		var self = this;
		var msg =  self.translations.deleteAlert;
		var options = {
			resizable	: false,
			noclose		: true,
            dialogClass : 'white',
			title		: Loc.g("Suppression"),
			buttons		: [
				{
					text : Loc.g("Non"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){
						Agenda.confirmDeleteAlert(id, calendarId, dashboard, type, isEventRecurring, startDateEventRecurring, typeDeleteRecurring, title);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(msg, options);

	},

	confirmDeleteAlert: function(id, calendarId, dashboard, type, isEventRecurring, startDateEventRecurring, typeDeleteRecurring, title){
		MyFacture.post(
			'agendaEvent',
			{
				'action'                    : "delete",
				'isEventRecurring'          : isEventRecurring,
				'startDateEventRecurring'   : startDateEventRecurring,
				'typeDeleteRecurring'       : typeDeleteRecurring,
				'id'                        : id,
				'calendarId'                : calendarId,
				'type'						: type,
				'title'						: title
			},
			function(data){
				if(data.type !== undefined && data.type == "task"){
					if($('#tasksOverviewListing_container').length > 0){
						Listing.update('tasksOverviewListing');
					} else if($('#tasksListing_container').length > 0){
						Listing.update('tasksListing');
					} else {
						$('#aevent_' + data.eventID).slideUp('normal', function(){
							$(this).remove();
						});
					}
                    Agenda.updateNbTasksOverview("minus");
                    window.EventBus.emit('timeline:deleteLog', {objectType: 'task', objectId: id});
				} else {
					if(data.result && data.result.type && data.result.type == "error"){
						Push.error(data.result.message);
					} else{
                        $('#calendar').fullCalendar('refetchEvents');
                        var linkid = data.id ? data.id : id
                        var linktype = data.type ? data.type : (type == 'event' ? 'event' : 'task')
                        window.EventBus.emit('timeline:deleteLog', {objectType: linktype, objectId: linkid});
					}
				}
				if (data.type == undefined) {
					data.type = "event";
				}
                window.EventBus.emit("refresh_" + data.type);
			}, "json"
		);
	},

	prepareTasksFilterForm : function(){
		var options = {
			data	: {
				action : 'updateListing'
			},
			success: function(data) {
				Agenda.processTasksFilterForm(data);
			},
			dataType: "json"
		};

		MyForm.prepare("tasksFilterForm", "tasks", options);
	},

	processTasksFilterForm : function(data){
		Listing.refresh(data.listingName, data, eval('data.'+data.metadatasName));
	},


	updateStaffTypeFilter : function(filter){
		if($('#'+filter+" option:selected").val() === 'staff'){
			$('.staffList').fadeIn('fast');
		}else{
			$('.staffList').fadeOut('fast');
		}
	},

	autoDateEnd: function(type, eventType) {
		var dateFormat = $('#aevent_start_date').attr('format');
		$('#aevent_recurring_displayButtonAll').val("N");

		var rawDays = {
			start   : $('#aevent_start_date').val(),
			end     : $('#aevent_end_date').val()
		};
		var startDateTs = rawDays['start'].split("/");
		var endDate = rawDays['end'].split("/");

		switch(dateFormat) {
			case 'mdy':
				var startDateTimestamp	= new Date(startDateTs[2], startDateTs[0]-1, startDateTs[1]).getTime();
				var endDateTimestamp	= new Date(endDate[2], endDate[0]-1, endDate[1]).getTime();
				break;
			case 'dmy':
				startDateTimestamp		= new Date(startDateTs[2], startDateTs[1]-1, startDateTs[0]).getTime();
				endDateTimestamp		= new Date(endDate[2], endDate[1]-1, endDate[0]).getTime();
				break;
		}

		if(startDateTimestamp > endDateTimestamp){
			if(type === "start"){
				var dateModif = rawDays['start'].split("/");
			} else {
				dateModif = rawDays['end'].split("/");
			}
			var date = Date.today().toString('dd/MM/yyyy');
			switch(dateFormat) {
				case 'mdy':
					var newDate		= new Date(dateModif[2], dateModif[0]-1, dateModif[1]);
					date			= newDate.toString('MM/dd/yyyy');
					break;
				case 'dmy':
					var newDate		= new Date(dateModif[2], dateModif[1]-1, dateModif[0]);
					date			= newDate.toString('dd/MM/yyyy');
					break;
			}
			if(type === "start"){
				$('#aevent_end_date').val(date);
			}else {
				$('#aevent_start_date').val(date);
			}
		}
		Agenda.autoStartHour(eventType);
	},

	autoEnd: function() {
		var timeformat		= $('#aevent_start_time').attr('timepickerformat');

		var rawDays			= {
			start			: $('#aevent_start_date').val(),
			end				: $('#aevent_end_date').val()
		};
		var rawHours		= {
			start			: $('#aevent_start_time').val(),
			end				: $('#aevent_end_time').val()
		};

		var newEnd			= {
			hour			: 0,
			minute			: 0,
			more			: ''
		};

		if(rawDays.start == rawDays.end) {
			var regex			= /:|\s/;
			var startHourSplit	= rawHours.start.split(regex);

			switch(timeformat) {
				case '12'		:
					/*
					 * 0 : hour
					 * 1 : minute
					 * 2 : am/pm
					 */
					if(parseInt(startHourSplit[0]) == 12 && startHourSplit[2] == 'pm') {
						newEnd.hour		= 12;
						newEnd.minute	= 55;
						newEnd.more		= 'pm';
					} else if (parseInt(startHourSplit[0]) == 12 && startHourSplit[2] == 'am') {
						newEnd.hour		= 1;
						newEnd.minute	= parseInt(startHourSplit[1]);
						newEnd.more		= 'pm';
					} else {
						newEnd.hour		= parseInt(startHourSplit[0]) + 1;
						newEnd.minute	= parseInt(startHourSplit[1]);
						newEnd.more		= startHourSplit[2];
					}
					break;
				case '24'		:
					/*
					 * 0 : hour
					 * 1 : minute
					 */
					if(startHourSplit[0] == 23) {
						// Pour 23h30 et plus
						newEnd.hour		= 23;
						newEnd.minute	= 55;
					} else {
						newEnd.hour		= parseInt(startHourSplit[0]) + 1;
						newEnd.minute	= parseInt(startHourSplit[1]);
					}
					break;
			}

			$('#aevent_end_time').timepicker('setTime', ((newEnd.hour < 10 && timeformat == 24) ? '0' : '') + newEnd.hour + ':' + (newEnd.minute < 10 ? '0' : '') + newEnd.minute + ((newEnd.more != '') ? ' ' + newEnd.more : ''));
		}
	},

	autoStartHour: function (eventType) {
		var timeformat = $('#aevent_start_time').attr('timepickerformat');

		var rawDays = {
			start: $('#aevent_start_date').val(),
			end: $('#aevent_end_date').val()
		};
		var rawHours = {
			start: $('#aevent_start_time').val(),
			end: $('#aevent_end_time').val()
		};
		rawHours['end'] = rawHours['end'] == "24:00" ? "00:00" : rawHours['end'];

		var newEnd = {
			hour: 0,
			minute: 0,
			more: ''
		};

		var startDateModif = rawHours['start'].split(":");
		var valueStart = startDateModif[0] * 3600 + startDateModif[1] * 60;
		var endDateModif = rawHours['end'].split(":");
		var valueEnd = endDateModif[0] * 3600 + endDateModif[1] * 60;

		if (rawDays.start == rawDays.end && valueStart >= valueEnd) {
			var regex = /:|\s/;
			var startHourSplit = rawHours.start.split(regex);

			switch (timeformat) {
				case '12':
					/*
					 * 0 : hour
					 * 1 : minute
					 * 2 : am/pm
					 */
					if (parseInt(startHourSplit[0]) == 12 && startHourSplit[2] == 'pm') {
						newEnd.hour = 12;
						newEnd.minute = 55;
						newEnd.more = 'pm';
					} else if (parseInt(startHourSplit[0]) == 12 && startHourSplit[2] == 'am') {
						newEnd.hour = 1;
						newEnd.minute = parseInt(startHourSplit[1]);
						newEnd.more = 'pm';
					} else if (eventType !== 'task') {
						newEnd.hour = parseInt(startHourSplit[0]) + 1;
						newEnd.minute = parseInt(startHourSplit[1]);
						newEnd.more = startHourSplit[2];
					} else {
						newEnd.hour = parseInt(startHourSplit[0]);
						newEnd.minute = parseInt(startHourSplit[1]);
						newEnd.more = startHourSplit[2];
					}
					break;
				case '24':
					/*
					 * 0 : hour
					 * 1 : minute
					 */
					if (startHourSplit[0] == 23) {
						// Pour 23h30 et plus
						newEnd.hour = 23;
						newEnd.minute = 55;
					} else if (eventType !== 'task') {
						newEnd.hour = parseInt(startHourSplit[0]) + 1;
						newEnd.minute = parseInt(startHourSplit[1]);
					} else {
						newEnd.hour = parseInt(startHourSplit[0]);
						newEnd.minute = parseInt(startHourSplit[1]);
					}
					break;
			}
			if (rawHours['end'] != "00:00") {
				var val = ((newEnd.hour < 10 && timeformat == 24) ? '0' : '') + newEnd.hour + ':' + (newEnd.minute < 10 ? '0' : '') + newEnd.minute + ((newEnd.more != '') ? ' ' + newEnd.more : '');
				$('#aevent_end_time').timepicker('setTime', val);
			}
		}
	},

	autoEndPrefs: function(type) {
		var timeformat = $('#agendaStartTime').attr('timepickerformat');

		var rawHours = {
			start   : $('#agendaStartTime').val(),
			end	: $('#agendaEndTime').val()
		};
                rawHours['end'] = rawHours['end'] == "24:00" ? "00:00" : rawHours['end'];

		var newEnd = {
			hour    : 0,
			minute	: 0,
			more	: ''
		};

		if(rawHours.start >= rawHours.end) {
			var regex           = /:|\s/;
			var startHourSplit  = rawHours.start.split(regex);

			switch(timeformat) {
				case '12' :
					/*
					 * 0 : hour
					 * 1 : minute
					 * 2 : am/pm
					 */
					if(parseInt(startHourSplit[0]) == 12 && startHourSplit[2] == 'pm') {
						newEnd.hour     = 12;
						newEnd.minute	= 55;
						newEnd.more	= 'pm';
					} else if (parseInt(startHourSplit[0]) == 12 && startHourSplit[2] == 'am') {
						newEnd.hour	= 1;
						newEnd.minute	= parseInt(startHourSplit[1]);
						newEnd.more	= 'pm';
					} else {
                                                newEnd.hour	= parseInt(startHourSplit[0]) + 1;
						newEnd.minute	= parseInt(startHourSplit[1]);
						newEnd.more	= startHourSplit[2];
					}
					break;
				case '24' :
					/*
					 * 0 : hour
					 * 1 : minute
					 */
					if(startHourSplit[0] == 23) {
						// Pour 23h30 et plus
						newEnd.hour	= 23;
						newEnd.minute	= 55;
					} else {
                                                newEnd.hour	= parseInt(startHourSplit[0]) + 1;
						newEnd.minute	= parseInt(startHourSplit[1]);
					}
					break;
			}

                        if(rawHours['end'] != "00:00") {
                            $('#agendaEndTime').val(((newEnd.hour < 10 && timeformat == 24) ? '0' : '') + newEnd.hour + ':' + (newEnd.minute < 10 ? '0' : '') + newEnd.minute + ((newEnd.more != '') ? ' ' + newEnd.more : ''));
                        }
		}
	},

	dashboardCalendarLoader: function(show) {
		if(show) {
			$('#agendaDashboardLoader').css({
				'display' : 'block',
				'z-index' : '999'
			});

			$('#dash-calendar-container').css({
				'overflow-y': 'none'
			});
		} else {
			$('#agendaDashboardLoader').hide();

			$('#dash-calendar-container').css({
				'overflow-y': 'scroll'
			});
		}
	},

	saveFilters: function(origin, filterModify) {

		var start   = $('#calendar').fullCalendar('getView').start;
		var end     = $('#calendar').fullCalendar('getView').end;

		// agenda_label
		if(origin == 'object'){
			var label = $('#pref_category').val();;
		} else {
			label = $('#agenda_label').val();
		}

		// agenda_object
		if(origin == "object"){
			var object = $('#pref_object').val();
		} else {
			object = $('#agenda_object').val();
		}

		//agenda_staffGroup
		if(origin == "object"){
			var staffGroup = $('#pref_staffGroup').val();
		} else {
			staffGroup = $('#agenda_staffGroup').val();
		}

		//agenda_calendar
		var nbCalendar = $('#nbCalendar').val();
		if(origin == "object"){
			var calendar = $('#pref_calendar').val();
		} else {
			calendar = $('#agenda_calendar').val();
		}
		var newNbCalendar = calendar != undefined && calendar != null ? calendar.length : 0;

		$('#calendar-loader').show();

		var href        = document.location.href;
		var href_array	= (href.search(/\?_f=/)) >= 0 ? href.split('?_f=') : href.slice(8).split('/');
		var isDashboard = ($('#dashboard').length > 0) ? "Y" : "N";
		var relatedType = $('#calendar').attr('relatedtype');
		var relatedId = $('#calendar').attr('relatedid');

		var action	= "agenda&action=updateEvents&forCalendar=Y";
		if(relatedType != undefined && relatedId != undefined){
			action	= "agenda&action=updateEvents&forCalendar=Y&relatedtype=" + relatedType + "&relatedid=" + relatedId;
		}
		var view	= $('#calendar').fullCalendar('getView');

		var dataAction = {
			start			: start.format('YYYY-MM-DD HH:mm:ss'),
			end				: end.format('YYYY-MM-DD HH:mm:ss'),
			location		: href_array[1],
			label			: JSON.stringify(label),
			object			: JSON.stringify(object),
			staffGroup		: JSON.stringify(staffGroup),
			calendar		: JSON.stringify(calendar),
			filterModify	: filterModify,
			view			: view.name
		};
		var success = function(data) {
			Listing.loader('hide', 'agendaListing');
			if(filterModify === "calendar"){
				if(nbCalendar < newNbCalendar){
					$("#calendar").fullCalendar('addEventSource', data);
				}else {
					$("#calendar").fullCalendar('removeEvents', function(event) {
						if(event.calendarId == data) {
							return true;
						}
						return false;
					});
				}
			} else {
				$("#calendar").fullCalendar('removeEvents');
				$("#calendar").fullCalendar('addEventSource', data);
			}

			$('#nbCalendar').val(newNbCalendar);
		};

		if(isDashboard === 'N') {
			MyFacture.post(action, dataAction, success, 'json', true);
		} else {
			MyFacture.post(action, dataAction, success, 'json');
		}
	},

	initRelateds : function() {

		var type		= $('#aevent_relatedtype').val();
		var token		= $('#aevent_relatedid').parent().find('.token-input-list');
		var element		= $('#aevent_relatedid');

		if($('#aevent_relatedid').is(':visible') || (token.length > 0)) {

			if(token.length > 0) {
				$('#__persistent__aevent_relatedid').remove();
				token.remove();
			}
			$('#aevent_relatedid').css('display', 'block');

			switch(type) {
				case 'third':
					var types = 'third|supplier|prospect';
					TokenInput.autoContact(element, types, null, 1);
					break;

				case 'people':
					TokenInput.autoPeople(element, 1, true);
					break;

				case 'item':
					var types = 'item|service';
					TokenInput.autoItem(element, types, '', 1);
					break;

				case 'docs':
					var docs = 'estimate|invoice|model|delivery|order|creditnote|proforma';
					TokenInput.autoDocumentListing(element, docs, 1, true);
					break;

				case 'purchases':
					var docs = 'purchase|purOrder|purDelivery|purInvoice|purCreditNote';
					TokenInput.autoDocumentListing(element, docs, 1, true);
					break;

				case 'opportunity':
					TokenInput.autoOpportunity(element, '', '', 1);
					break;

				case 'support':
					TokenInput.autoSupport(element, '', '', 1);
					break;

				case 'projectEntry':
					TokenInput.autoProjectEntry(element, '', '', null, 1);
					break;

				case 'campaign':
				    var types = 'email|sms';
					TokenInput.autoCampaign(element, types, 1);
					break;
				case 'propdocument':
					var types = 'propdocument';
					TokenInput.autoProposal(element, types, 2, null,null, null, true);
					break;

			}
		}
	},

    loadTasksTab: function (type, id) {

        var prefilter = {'type': type, 'id' : id, 'taskStatus' : 'ok'};

        if ($('#content_tasks .tasks_content').html() === '') {

            var options = {
                action		: "loadListingTab",
                listing		: 'tasks',
                prefilter	: JSON.stringify(prefilter)
            };

            MyFacture.post('tabs', options, function (data) {
                $('#content_tasks .tasks_content').html(data.listing);
                Listing.init(data.prefix);

                var options = {
                    data: {
                        action		: 'updateListingTab',
                        listing		: 'tasks',
                        prefilter	: JSON.stringify(prefilter)
                    },
                    success: function (data) {
                        Listing.refresh(data.listingName, data, data[data.metadatasName]);
						if($('.tabTaskCount').length > 0 && data.tasksOverview_metadatas !== undefined && data.tasksOverview_metadatas.nbTotal !== undefined){
							if(data.tasksOverview_metadatas.nbTotal < 1) {
								$('.tabTaskCount').text(0).hide();
							} else {
								$('.tabTaskCount').text(data.tasksOverview_metadatas.nbTotal).show();
							}
						}
                    },
                    dataType: "json"
                };
                MyForm.prepare(data.listingname + "FilterForm", "tabs", options);
                MyFacture.customForm('#content_tasks');
            }, 'json');
        }
    },

	responseParticpant : function(eventId, calendarId, email, status, isRecurringEvent, recurringEventId){

		if(isRecurringEvent != undefined && isRecurringEvent == 'Y'){
            var buttons = [];
            buttons.push({
				text : Loc.g("Enregistrer"),
				click : function(){
                    Agenda.validateResponseParticipant(eventId, calendarId, email, status, isRecurringEvent, $('input[name=aevent_checkRecurring]:checked').val(), recurringEventId);
					$(this).dialog("close");
				}
			});
            buttons.push({
				text : Loc.g("Annuler"),
				click : function(){
                    $(this).dialog("close");
				}
			});
            var options = {
                    title   : Loc.g("Vérification de l'évènement récurrent"),
                    buttons : buttons,
                    width   : 900
            };
            MyWindow.load("agendaEvent", {action:"checkRecurring", displayButtonNext : 'N'}, options, undefined, 'idCheckRecurring');
		} else {
			Agenda.validateResponseParticipant(eventId, calendarId, email, status, isRecurringEvent, "all", "");
		}
	},

	validateResponseParticipant : function (eventId, calendarId, email, status, isRecurringEvent, valueModifyRecurringEvent, recurringEventId){
		var action = "agenda&action=responseParticipant";
		var dataAction = {
			eventId						: eventId,
			calendarId					: calendarId,
			email						: email,
			status						: status,
			isRecurringEvent			: isRecurringEvent,
			valueModifyRecurringEvent	: valueModifyRecurringEvent,
			recurringEventId			: recurringEventId
		};

		var success = function(data) {
			if(data.status == "failed" && data.error != undefined){
				Push.error(data.error);
			} else {
				$('#calendar').fullCalendar('refetchEvents');
			}
		};

		MyFacture.post(action, dataAction, success, 'json');
	},

	forceSynchroCalendar : function() {

		var self = this;

		MyWindow.wait(undefined, self.translations.updateCalendar);

		MyFacture.post(
			'agenda',
			{
				action : 'forceSynchroCalendar'
			},
			function(data){
				MyWindow.awake();
				if(data.status == 'ko'){
					var msg = data.message != "" ? data.message : self.translations.updateCalendarKo;
					Push.error(msg);
				}
			},
			"json"
		);
	},

	refreshAgenda : function() {
		$('#calendar').fullCalendar('refetchEvents');
	},

	initActiveDisplayMode: function () {
		var $container = $(".fc-view-container > .fc-view");

		if ($container.hasClass("fc-basic-view")) {
			$("#js-agenda-calendar").addClass("semibold bb-2-blue");
		}
		else if ($container.hasClass("fc-list-view")) {
			$("#js-agenda-list").addClass("semibold bb-2-blue");
		}
	},

	updateActive: function (el) {
		$(el).parents("ul").find("a").removeClass("semibold bb-2-blue");
		$(el).addClass("semibold bb-2-blue");
	},

	preview: function(eventId, calendarId, isPrivate, startDate, endDate, isEventRecurring, title) {
        var self     = this;
        var settings = {
            class: self.settings.route,
			width: 'small',
            callback: function(data) {

				var dataDetail	 = $('.eventTips').attr("data-detail");
				var dataEditable = $('.eventTips').attr("data-editable");
				var dataTitle	 = $('.eventTips').attr("data-title");
				var dataPrivate	 = $('.eventTips').attr("data-private");
				if(dataPrivate == 'Y'){
					dataTitle = self.translations.eventPrivate;
				}

				if(dataEditable === "Y"){
					if(dataDetail === "Y"){
						//On ajoute les deux boutons
						//Bouton delete
						var buttonDelete = {
							name	: self.translations.deleteButton,
							id		: 'btnDeleteDetailEvent',
							action	: function() {
								if(isEventRecurring == "Y"){
									Agenda.checkDeleteRecurring(eventId, calendarId, 'event', $('#tsStartRecurringEvent').val(), title);
								} else {
									Agenda.deleteAlert(eventId, calendarId, false, 'N', 'event', '', '', title);
								}
								Panel.prototype.close();
							}
						};
						Panel.prototype.addButton(buttonDelete);

						//Bouton modifier
						var buttonModify = {
							name	 : self.translations.modifyButton,
							class	 : 'btn-primary',
							id		 : 'btnModifyDetailEvent',
							action	 : function() {
								Agenda.editForm(eventId, calendarId, undefined, undefined, undefined, 'event', undefined, undefined, isEventRecurring, startDate, endDate, title);
								Panel.prototype.close();
							}
						};
						Panel.prototype.addButton(buttonModify, 'right');

					} else {
						//On affiche uniquement le bouton supprimer
						var buttonDelete = {
							name	: self.translations.deleteButton,
							id		: 'btnDeleteDetailEvent',
							action	: function() {
								if(isEventRecurring == "Y"){
									Agenda.checkDeleteRecurring(eventId, calendarId, 'event', $('#tsStartRecurringEvent').val(), title);
								} else {
									Agenda.deleteAlert(eventId, calendarId, false, 'N', 'event', title);
								}
								Panel.prototype.close();
							}
						};
						Panel.prototype.addButton(buttonDelete);
					}
				}

				Panel.prototype.setTitle(dataTitle);

                // Init Qtip();
                Qtip.init();
            },
            beforeClose: function(event, ui) {
                // Clean all current XHR
                MyFacture.cleanQueue();
            }
        };
        var panel  = new Panel(settings);
        var params = {
            action		: 'tipslog',
            eventId		: eventId,
			calendarId	: calendarId,
			startDate	: startDate,
			endDate		: endDate,
        };

        panel.open(self.settings.route, params);
	},

    getComponentNylasScheduler(container) {

        if ($(container).length) {
            let Component = Vue.extend({
                template: `<nylas-scheduler />`,
                components: {
                    NylasScheduler,
                }
            });

            return new Component().$mount(container);
        }
    },

};

window.AgendaTab = {

    loadAgendaTab: function(relatedType, relatedId, nameCallbackFunction, prefixXsl, forceLocation)
	{
		var agendaContent = $('#agenda_content');
		if (agendaContent.length == 0) {
			MyFacture.post(
				'agenda',
				{
					action 				 : 'loadAgendaTab',
					relatedType 		 : relatedType,
					relatedId 			 : relatedId,
					nameCallbackFunction : nameCallbackFunction,
					forceLocation		 : forceLocation
				},
				function(data){
					$('#content_agenda').children().prepend(data.agenda);

					var id = '#' + prefixXsl + '-fullcalendar';
					var hasMigrateApp = $('#hasMigrateApp').val();
					var reconnectModule = $('#reconnectModule').val();

					if (hasMigrateApp == 'N' || reconnectModule == 'Y') {
						$(id).remove();
					}

					if (reconnectModule == 'N' && hasMigrateApp == 'Y') {
						eval(data.callback);
					}
					Agenda.initFilter("object");
					MyFacture.customForm('#content_agenda');

					if(forceLocation){
						$('.event-filter-block').hide()
					}
				},
				"json",
				true
			);
		}
	}
};
